<kno2-dialog-body>
    <div class="alert alert-info">
        <p>
            <strong>This organization has been canceled.</strong>
            <br />
            This organization was canceled either by an admin or due to non-payment. You must be an administrator of this organization in order to reactivate
            the subscription. Please contact your previous organization admin to have them reactivate this organization.
        </p>
    </div>
</kno2-dialog-body>

<kno2-dialog-footer>
    <button
        type="button"
        class="btn btn-primary"
        (click)="logout()">
        Logout
    </button>
</kno2-dialog-footer>
